export default function Footer() {
  return (
    <footer>
     
        Coded by Hinako
    </footer>
  );
}
